<template>
  <div>
    <Dialog :initialFocus="verifyAccountButtonRef" as="div" class="relative z-100">
      <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0" enter-to="opacity-100"
        leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-black/90" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4 text-center">
          <TransitionChild as="template" enter="duration-300 ease-out absolute "
            enter-from="opacity-0 scale-95 bottom-full" enter-to="opacity-100 scale-100 bottom-[35%]"
            leave="duration-200 ease-in absolute" leave-from="opacity-100 scale-100 bottom-[35%]"
            leave-to="opacity-0 scale-95 bottom-full">
            <DialogPanel
              class="flex flex-col w-[407px] max-w-md transform rounded-2xl bg-white p-6 text-start align-middle shadow-xl transition-all  h-[619px] max-h-[75vh]">
              <a role="button" @click="cancel()" class="absolute md:-top-0 -top-10 md:-right-[8%] right-0 ">
                <img src="../../assets/images/icons/ic-close-light.svg" width="21" height="21" />
              </a>
              <DialogTitle as="h3" class=" leading-6 ">
                <h5 class="text-dark-4 font-bold text-2xl">{{t('modal.Your_Activation_Code')}}</h5>
                <p class="text-dark-2 mt-4 font-regular">
                  {{t('modal.otp_subtitle')}}
                </p>
              </DialogTitle>
              <!-- Dialog Content  -->
              <div class="mt-auto">
                <section class="text-sm text-gray-500">
                  <form name="modalForm" @submit.prevent="confirmAccVerfication()">
                    <div class="flex justify-start gap-x-3 flex-nowrap mx-auto w-[65%]">
                      <input
                        class="otp-input bg-[#DEDEDE] w-12 h-12 text-center rounded-md border-0 focus:outline-0 focus:ring-0 focus:border-[transparent] !outline-0 transition duration-150 ease-in-out"
                        maxlength="1" @input="autoTap()" v-model="OTPNumber.NO1" required autocomplete="off"
                        v-numberOnly type="text" />
                      <input
                        class="otp-input bg-[#DEDEDE] w-12 h-12 text-center rounded-md border-0 focus:outline-0 focus:ring-0 !outline-0 active:shadow-sm transition duration-150 ease-in-out"
                        maxlength="1" @input="autoTap()" v-model="OTPNumber.NO2" required autocomplete="off"
                        v-numberOnly type="text" />
                      <input
                        class="otp-input bg-[#DEDEDE] w-12 h-12 text-center rounded-md border-0 focus:outline-0 focus:ring-0 !outline-0 active:shadow-sm transition duration-150 ease-in-out"
                        maxlength="1" @input="autoTap()" v-model="OTPNumber.NO3" required autocomplete="off"
                        v-numberOnly type="text" />
                      <input
                        class="otp-input bg-[#DEDEDE] w-12 h-12 text-center rounded-md border-0 focus:outline-0 focus:ring-0 !outline-0 active:shadow-sm transition duration-150 ease-in-out"
                        maxlength="1" @input="autoTap()" v-model="OTPNumber.NO4" required autocomplete="off"
                        v-numberOnly type="text" />
                    </div>
                    <p class="text-dark-gray-3 font-medium text-center mt-6">
                          {{t('modal.Issue_with_sending')}}
                        <a role="button" @click="sendOTP()" 
                        class="text-dark-4 font-bold underline"
                        :class="{'!text-gray-400 !font-normal': isOTPCodeSent}">
                        {{ t('buttons.Resend') }}
                        </a>
                      </p>
                    <div class="mt-20 flex flex-col justify-end">
                      <primary-button type="submit" class="m-auto w-full cursor-pointer">
                        {{t('modal.Verfiy_Phone_No')}}
                      </primary-button>
                    
                    </div>
                  </form>
                </section>
              </div>
            </DialogPanel>
          </TransitionChild>

        </div>
      </div>
    </Dialog>

    <!-- loader -->
    <Loader :modalIsOpen="isLoading" :initFocusedRef="verifyAccountButtonRef" class="" :widthSM="true"></Loader>
  </div>

</template>
<script>
import { ref, onBeforeMount } from "vue";
import { useStore } from "vuex"
import { numberOnly } from "@/common/Directives/numberOnly";
import { useI18n } from "vue-i18n";
import Request from "@/common/Request"
import Response from "@/common/Response"

import PrimaryButton from "@/components/atoms/buttons/PrimaryButton";
import Loader from "@/components/atoms/Loader";

import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  //   TransitionRoot
} from '@headlessui/vue';

export default {
  name: "otp-modal",
  directives: {
    numberOnly: numberOnly,
  },
  components: {
    Loader,
    PrimaryButton,
    Dialog,
    DialogTitle,
    DialogPanel,
    TransitionChild,
  },
  emits: ["cancel"],
  setup(props, { emit }) {
    const { t } = useI18n();
    const store = useStore()
    const isLoading = ref(false)
    const isOTPCodeSent = ref(false)
    
    const verifyAccountButtonRef = ref()
    const OTPNumber = ref({
      NO1: null,
      NO2: null,
      NO3: null,
      NO4: null,
    })
    const autoTap = function () {
      var ele = document.getElementsByClassName("otp-input");
      Array.from(ele).forEach(function (ele) {
        ele.addEventListener("keyup", function (event) {
          // Number 13 is the "Enter" key on the keyboard
          if (event.keyCode === 13 || ele.value.length == 1) {
            ele.nextElementSibling?.focus();
          }
        });
      });
    }
    const getCompletedOTP = function () {
      let completed_OTP = ''
      Object.keys(OTPNumber.value).forEach(key => {
        completed_OTP += String(OTPNumber.value[key])
      });
      return completed_OTP
    }

    const confirmAccVerfication = async function () {
      isLoading.value = true
      let payload = {
        otp: getCompletedOTP(),
      }
      //  verify Account request
      new Request().post("otp", payload).then((res) => {
        if (res?.data) {
          
          //update user data
          store.commit("updateAccountStatus", res?.data?.data)

          setTimeout(() => {
            isLoading.value = false
          })

          //cancel otp modal
          setTimeout(() => {
            emit('cancel')
            new Response({ message: res.data.message }).displaySuccess()
          }, 350)

        } else {
          isLoading.value = false
        }

      }, (err) => {
        new Response({ message: t('messages.Internal_Error') }).displayErrors()

        isLoading.value = false

      })

    }

    const sendOTP = async function () {
      if(isOTPCodeSent.value == false) {
        isOTPCodeSent.value = true
      await new Request().post("otp/resend").then((res) => {
        //display success toaster
        new Response({ message: t('messages.OTP_sent') }).displaySuccess()
        setTimeout(()=> {
          isOTPCodeSent.value = false
        },10000)

      }, (err) => {
        new Response({ message: t('messages.Internal_Error') }).displayErrors()

        isOTPCodeSent.value = false
      })
      }
  
    }

    onBeforeMount(() => {
      sendOTP()
    })
    return {
      t,
      isLoading,
      isOTPCodeSent,
      verifyAccountButtonRef,
      OTPNumber,
      cancel() {
        //reset form
        OTPNumber.value = {
          NO1: null,
          NO2: null,
          NO3: null,
          NO4: null,
        }
        emit('cancel')
      },
      autoTap,
      confirmAccVerfication,
      sendOTP
    }
  }
}
</script>
<style lang="">
 
</style>